import { createContext, useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isPossiblePhoneNumber } from "libphonenumber-js";

import { isValidEmail } from "../utils/helpers";

import useApi from "../hooks/useApi";

const LoginDataContext = createContext({});

export const LoginDataProvider = ({ children }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginValidation, setLoginValidation] = useState("");

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { post, loading } = useApi();

  const resetState = () => {
    setPhoneNumber("");
    setEmail("");
    setPassword("");
    setLoginValidation("");
  };

  const FetchAuth = async (loginType) => {
    if ((email.trim === "" && phoneNumber.trim() === "") || password === "") {
      setLoginValidation(t("error_login_field_empty"));
      return;
    }

    if (loginType === "mobile") {
      if (isPossiblePhoneNumber("+" + phoneNumber) !== true) {
        setLoginValidation(t("error_mobile"));
        return;
      }
    }

    if (loginType === "email") {
      if (!!email && !isValidEmail(email)) {
        setLoginValidation(t("error_email_format"));
        return;
      }
    }

    try {
      setLoginValidation("");
      const data = await post("/User/login", {
        ...(loginType === "email" && { email }),
        ...(loginType === "mobile" && { phoneNumber }),
        password,
        rememberLogin: true,
      });
      if (!data.token) {
        setLoginValidation(t("error_login_field_incorrect"));
        return;
      }

      localStorage.setItem("ps10005000", JSON.stringify(data.token));
      localStorage.setItem("ps10004000", JSON.stringify(data.refreshToken));

      resetState();
      const redirectPathAfterLogin =
        location.state?.from?.pathname || "/sessions";

      navigate(redirectPathAfterLogin, { replace: true });
    } catch (error) {
      setLoginValidation(t("error_login_not_found"));
    }
  };

  return (
    <LoginDataContext.Provider
      value={{
        phoneNumber,
        email,
        password,

        changePhoneNumber: setPhoneNumber,
        changeEmail: setEmail,
        changePassword: setPassword,

        FetchAuth,
        loginValidation,
        loginLoader: loading,
      }}
    >
      {children}
    </LoginDataContext.Provider>
  );
};

const useLogin = () => useContext(LoginDataContext);

export default useLogin;
